/** Return types of react-native's Platform.OS */
const REACT_NATIVE_PLATFORMS = ['ios', 'android', 'windows', 'macos', 'web'] as const
type REACT_NATIVE_PLATFORM = (typeof REACT_NATIVE_PLATFORMS)[number]

const REACT_NATIVE_PLATFORMS_SET = new Set(REACT_NATIVE_PLATFORMS)

/**
 * React-native in hager-energy-mobile-apps injects a global variable 'isInWebView' into the window object,
 * which has the value of react-native's Platform.OS.
 *
 * @returns false if the app is NOT in react-native's webview. The Platform.OS value if it is.
 */
export const getIsInWebView = (): REACT_NATIVE_PLATFORM | false => {
  if (!('isInWebView' in window)) return false

  const isInWebView = window.isInWebView as REACT_NATIVE_PLATFORM | false
  if (typeof isInWebView !== 'string' || !REACT_NATIVE_PLATFORMS_SET.has(isInWebView)) return false

  return isInWebView
}

/** React-native in hager-energy-mobile-apps injects a global variable 'WEBVIEW_VERSION' into the window object. */
export const getWebViewVersion = (): number => {
  if (!('WEBVIEW_VERSION' in window)) return 0

  return window.WEBVIEW_VERSION as number
}
